/**
 * Display a file's type based on extension
 */

export default (Vue) => {
	Vue.filter('inv-filetype', value => {
		return fileTypeDisplay(value);
	});

	Vue.prototype.$invFiletype = value => {
		return fileTypeDisplay(value);
	};

	/**
	 * Display a file's type based on extension
	 *
	 * @param {string} value
	 *
	 * @usage {{ ext | inv-filetype }}
	 *     '.jpg' => 'Image'
	 */
	function fileTypeDisplay(value) {
		if (! value) {
			return '';
		}

		switch (value.toLowerCase()) {
			case 'bmp':
			case 'jpg':
			case 'jpeg':
			case 'gif':
			case 'png':
				return 'Image';
				break;
			case 'css':
				return 'Cascading Stylesheet';
				break;
			case 'doc':
			case 'docx':
				return 'Microsoft Word Document';
				break;
			case 'html':
			case 'htm':
				return 'HTML Document';
				break;
			case 'js':
				return 'JavaScript';
				break;
			case 'odf':
				return 'Open Office Document';
				break;
			case 'pdf':
				return 'PDF';
				break;
			case 'ppt':
			case 'pptx':
				return 'Microsoft Powerpoint';
				break;
			case 'pub':
				return 'Microsoft Publisher';
				break;
			case 'txt':
				return 'Text Document';
				break;
			case 'xls':
			case 'xlsx':
				return 'Microsoft Excel Workbook';
				break;
			case 'zip':
				return 'Compressed Archive';
				break;
			default:
				console.warn(`[Invizon] warn: Unknown file extension: ${value}`);
				return 'Unknown File';
				break;
		}
	}
};